export default values => {
    const errors = {};

    if (!values["users"] || (values["users"] && values["users"].length === 0)) {
        errors["users"] = "Required";
    }

    return errors;
};
